module.exports = __webpack_public_path__ + "media/images/ecobank-13f92b9842bdbdc89d3ba715aba777d8.jpg";